export enum SensorConfigViewModelType {
    None = 0,
    Lms = 1
}

export enum DataPointState {
    AlwaysOn = 0,
    GoingOffline = 1,
    Offline = 2,
    GoingOnline = 3,
    Online = 4,
    Error = 5
}
export enum ModelMessageMode {
    Debug = 0,
    Info = 1,
    Warning = 2,
    Error = 3
}
export enum SensorOperationState {
    Unknown = 0,
    Starting = 1,
    Running = 2,
    Stopping = 3,
    Completed = 4,
    Failed = 5,
    Disposed = 6
}
export enum SiteState {
    NotConfigured = 0,
    ConfigurationSetupActive = 1,
    SensorDiscoveryRunning = 2,
    SensorDiscoveryCompleted = 3,
    SensorDiscoveryFailure = 4,
    SensorUpdateRunning = 5,
    SensorUpdateCompleted = 6,
    SensorUpdateFailure = 7,
    ConfigurationInitializing = 8,
    ConfigurationInitializationFailure = 9,
    ConfigurationStarting = 10,
    ConfigurationRunning = 11,
    ConfigurationRunningError = 12,
    ConfigurationStopping = 13,
    ConfigurationFinalizing = 14,
    ConfigurationFinalizationFailure = 15
}
export enum WizardDeviceInfoDeviceCategory {
    Capturing = 0,
    AxleDetection = 1,
    PostProcessing = 2
}
export enum WizardFpsSetup {
    SingleLane,
    SingleLaneWithAC,
    DoubleLaneShared
}

export enum PointFlags {
    None = 0,
    All = 65535,
    Error = 1,
    Dazzled = 2,
    OutOfRange = 4,
    Glared = 8,
    Particle = 16,
    Uncertain = 32,
    Spindrift = 64,
    SecondarySource = 128,
    Foreground = 256,
    Suppressed = 512,
    Background = 1024
}

export enum ResultPartCategory {
    None = 0,
    Area = 1,
    Wheel = 4,
    Axle = 5,
    LicensePlate = 2,
    DangerousGoodsPlate = 3,
    Infringement = 6
}
export enum ResultPartSide {
    None = 0,
    Front = 1,
    Rear = 2,
    Left = 3,
    Right = 4,
    Top = 5,
    Bottom = 6
}
export enum MaintenanceViewState {
    Loaded = 0,
    Executing = 1,
    Executed = 2
}

